import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://its-sold.com';

// Routes that should NOT be indexed by search engines
const NOINDEX_PATHS = [
  '/admin', '/dashboard', '/login', '/register', '/forgot-password',
  '/reset-password', '/2fa', '/auth', '/create-listing', '/import-listing',
  '/media-kit', '/upgrade', '/seo-tools', '/marketplace-tools',
  '/realtor-dashboard', '/realtor-application', '/request-agent',
  '/vet-buyer', '/buyer-verification'
];

/**
 * Global SEO enforcer — runs on every route change.
 * - Sets canonical URL on every page
 * - Updates og:url
 * - Adds noindex to private/auth pages
 */
const CanonicalURL = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const canonicalUrl = `${SITE_URL}${path === '/' ? '' : path}`;

    // Set canonical
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);

    // Update og:url
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', canonicalUrl);
    }

    // Handle noindex for private pages
    let robotsMeta = document.querySelector('meta[name="robots"]');
    const isPrivate = NOINDEX_PATHS.some(p => path.startsWith(p));

    if (isPrivate) {
      if (robotsMeta) {
        robotsMeta.setAttribute('content', 'noindex, nofollow');
      }
    } else {
      if (robotsMeta) {
        robotsMeta.setAttribute('content', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
      }
    }
  }, [location.pathname]);

  return null;
};

export default CanonicalURL;
